// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/select_arow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/ongoing.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/sold.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.TableViewPopup_dashboard__Bk8Cv {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  overflow-y: auto;
  padding-right: 0px;
}

.TableViewPopup_dashboardContain__tpS2Y {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.TableViewPopup_bodythemedark__eT38U .TableViewPopup_dashboardContain__tpS2Y,
.TableViewPopup_bodythemedark__eT38U .TableViewPopup_dashboard__Bk8Cv,
.TableViewPopup_bodythemedark__eT38U .TableViewPopup_cont2__WSly8 {
  background-Color: #0f1824;
}

.TableViewPopup_top_header__PG0wA .TableViewPopup_top_header_inner__z02ox {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.TableViewPopup_cont2__WSly8 {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  /*height: calc(100vh - 160px);*/
  height: 100%;
  min-height: auto !important;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.TableViewPopup_subLink__pQ1zR svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.TableViewPopup_cst_vendr__WSWVq input {
  min-height: 35px !important;
}

.TableViewPopup_cst_vendr__WSWVq .TableViewPopup_form-control__H1J3C {
  background-color: #f5f6fa;
  border: none;
}

.TableViewPopup_footer__6yLKS {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.TableViewPopup_bodythemelight__fp7qv {
  background-color: #fff;
  padding-top: 90px;
}

.TableViewPopup_bodythemedark__eT38U {
  background-color: #132337;
  padding-top: 90px;
}

.TableViewPopup_bodythemeNew__Emjeb {
  background-color: #f5f6fa;
}

/* 
Header Navbar Theme
*/
.TableViewPopup_headerthemelight__Jza1g {
  background-color: #fff;
}

.TableViewPopup_headerthemedark__LXffa {
  background-color: #132337;
}

.TableViewPopup_top_header__PG0wA {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 2;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.TableViewPopup_menuthemelight__LhB3c {
  background-color: #f5f6fa;
}

.TableViewPopup_menuthemedark__kDS-2 {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.TableViewPopup_menulinklight__X6MCA span {
  color: #666666 !important;
}

.TableViewPopup_menulinklight__X6MCA a {
  color: #CBCBCB !important;
}

.TableViewPopup_menulinklight__X6MCA:hover span,
.TableViewPopup_menulinklight__X6MCA:hover a {
  color: #fff !important;
}

.TableViewPopup_menulinkdarkSelected__O\\+6\\+L {
  background-color: #1c2e45;
  color: #3b82f6;
}

.TableViewPopup_menuthemelight__LhB3c .TableViewPopup_menulinklightSelected__QmHyj {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43 !important;
}

.TableViewPopup_menulinkdark__0CoHZ {
  color: #92afd3 !important;
}

.TableViewPopup_menulinklight__X6MCA:hover {
  color: #fff !important;
  background-color: #131F43 !important;
}

.TableViewPopup_menulinklight__X6MCA .TableViewPopup_sub_arrow__qZFKh svg path {
  stroke: #CBCBCB !important;
}

.TableViewPopup_menulinklight__X6MCA:hover .TableViewPopup_sub_arrow__qZFKh svg path {
  stroke: #fff !important;
}

.TableViewPopup_menulinkdark__0CoHZ .TableViewPopup_sub_arrow__qZFKh svg path {
  stroke: #92afd3 !important;
}

.TableViewPopup_menulinkdark__0CoHZ:hover .TableViewPopup_sub_arrow__qZFKh svg path {
  stroke: #fff !important;
}

.TableViewPopup_menulinklight__X6MCA:hover svg path,
.TableViewPopup_menulinklightSelected__QmHyj svg path {
  fill: #fff !important;
}

.TableViewPopup_menulinkdark__0CoHZ:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.TableViewPopup_headinglight__X-ybd {
  color: #60677e;
}

.TableViewPopup_headingdark__K-CKc {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.TableViewPopup_searchboxlight__IW4y0 {
  background-color: #fff;
  border: none;
}

.TableViewPopup_searchboxdark__yI0sj {
  background-color: #132337;
  color: #fff;
  border: none;
}

.TableViewPopup_searchboxdark__yI0sj::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.TableViewPopup_tableheadlight__fLoF6 {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.TableViewPopup_tableheadlight__fLoF6 th {
  color: #fff;
}

thead .TableViewPopup_tableheadlight__fLoF6 th:first-child,
thead .TableViewPopup_tableheaddark__ByeKf th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .TableViewPopup_tableheadlight__fLoF6 th:last-child,
thead .TableViewPopup_tableheaddark__ByeKf th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.TableViewPopup_table__p20dt.TableViewPopup_table-borderless__6wz24 {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.TableViewPopup_tableheaddark__ByeKf {
  background-color: #132337;
  color: #fff;
}

.TableViewPopup_table-borderless__6wz24 tr:nth-child(even) {
  background-color: #F9FAFB;
}

.TableViewPopup_table-borderless__6wz24 .TableViewPopup_left-section__YKZOb {
  padding-top: 10px;
}

.TableViewPopup_tablebodylight__eYYYF td,
.TableViewPopup_tablebodydark__jZy-n td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.TableViewPopup_tablebodylight__eYYYF {
  background-color: #fff;
}
.TableViewPopup_tablebodylight__eYYYF:hover {
  background-color: #fff;
  cursor: auto;
}
.TableViewPopup_tablebodylight__eYYYF p {
  line-height: 24px;
}

.TableViewPopup_tablebodydark__jZy-n {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.TableViewPopup_tablebodydark__jZy-n:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: pointer;
}

/* 
PAGINATION THEME COLOR
*/
.TableViewPopup_paginationlight__x\\+QwH {
  color: #60677e !important;
  font-size: 13px !important;
}

.TableViewPopup_paginationdark__jrN5e {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.TableViewPopup_formthemelight__9E6G5 {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.TableViewPopup_formthemedark__SEbrt {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.TableViewPopup_formthemedark__SEbrt ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.TableViewPopup_viewformlight__pK93I {
  background-color: #f3f6f9;
}

.TableViewPopup_permissionboxlight__omoDD {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.TableViewPopup_permissionboxdark__dI-1S {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.TableViewPopup_errormsgclr__40cyw {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.TableViewPopup_graphclrlight__SG\\+F5 {
  background-color: #fff;
}

.TableViewPopup_graphclrdark__TCTv8 {
  background-color: #132337;
}

/* 
Counter theme
*/
#TableViewPopup_card1bglight__xbpCL {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#TableViewPopup_card1bgdark__Q9o0M {
  background: #392f28;
}

#TableViewPopup_card2bglight__qvHLE {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#TableViewPopup_card2bgdark__fuIJ1 {
  background: #1c3238;
}

#TableViewPopup_card3bglight__ybE2T {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#TableViewPopup_card3bgdark__UNBgK {
  background: #3a2434;
}

#TableViewPopup_card4bglight__TKUGy {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#TableViewPopup_card4bgdark__1QTv4 {
  background: #2f264f;
}

#TableViewPopup_card1bgdark__Q9o0M a,
#TableViewPopup_card1bgdark__Q9o0M p,
#TableViewPopup_card2bgdark__fuIJ1 a,
#TableViewPopup_card2bgdark__fuIJ1 p,
#TableViewPopup_card3bgdark__UNBgK a,
#TableViewPopup_card3bgdark__UNBgK p,
#TableViewPopup_card4bgdark__1QTv4 a,
#TableViewPopup_card4bgdark__1QTv4 p {
  color: #fff;
}

/* 
Action button theme
*/
.TableViewPopup_actionbtnlight__gwhXA {
  color: rgba(70, 71, 91, 0.8705882353);
}

.TableViewPopup_actionbtndark__a9GeW {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.TableViewPopup_profiledropdownlight__Ky5fH {
  background-color: #fff;
}

.TableViewPopup_profiledropdowndark__0TwsG {
  background-color: #151521;
}

.TableViewPopup_settingsection__1qZmP #TableViewPopup_addform__-eoSQ.TableViewPopup_formthemedark__SEbrt .TableViewPopup_savebtn__V2WZc {
  background-color: #3b82f6;
  color: #fff;
}

#TableViewPopup_addform__-eoSQ.TableViewPopup_formthemedark__SEbrt .TableViewPopup_savebtn__V2WZc {
  background-color: #3b82f6;
  color: #fff;
}

.TableViewPopup_profile_conatiner__0Hgao {
  border-radius: 5px !important;
}

.TableViewPopup_bodythemedark__eT38U .TableViewPopup_ag-theme-alpine__pH-D3 .TableViewPopup_ag-row__2cNcJ {
  background: #000 !important;
}

.TableViewPopup_bodythemedark__eT38U .TableViewPopup_formbtn__CH0BD {
  background-color: #3b82f6;
}

.TableViewPopup_bodythemedark__eT38U .TableViewPopup_formbtn__CH0BD:hover {
  background-color: #2563eb;
}

.TableViewPopup_bodythemedark__eT38U .TableViewPopup_resetbtn__N\\+kZd {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.TableViewPopup_bodythemedark__eT38U .TableViewPopup_resetbtn__N\\+kZd:hover {
  background-color: #3b82f6;
}

.TableViewPopup_headingdark__K-CKc span {
  background-color: #132337;
}

.TableViewPopup_resetbtn__N\\+kZd {
  font-size: 16px !important;
  font-weight: 600 !important;
  border-radius: 5px !important;
  background-color: transparent !important;
  border: solid 1px #131F43 !important;
  color: #131F43 !important;
  min-width: 113px !important;
}

.TableViewPopup_resetbtn__N\\+kZd:hover,
.TableViewPopup_resetbtn__N\\+kZd:active,
.TableViewPopup_resetbtn__N\\+kZd:focus {
  background-color: #131F43 !important;
  color: #fff !important;
}

.TableViewPopup_addBtn__IqAbp {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.TableViewPopup_addDltBtn__rspPp {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.TableViewPopup_addbtnlight__G65nX {
  background-color: #38A169;
}

.TableViewPopup_addbtndark__\\+1j0r {
  background-color: #3b82f6;
}

.TableViewPopup_addbtndark__\\+1j0r:hover {
  background-color: #2563eb;
}

.TableViewPopup_formthemedark__SEbrt label {
  color: #92afd3;
}

.TableViewPopup_addBtn__IqAbp svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.TableViewPopup_addBtn__IqAbp:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.TableViewPopup_cust_addBtn__sKmpU.TableViewPopup_addBtn__IqAbp svg {
  top: 2px;
}

.TableViewPopup_deleteBtn__\\+PFBA {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.TableViewPopup_deleteBtn__\\+PFBA {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.TableViewPopup_deleteBtn__\\+PFBA:active,
.TableViewPopup_deleteBtn__\\+PFBA:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.TableViewPopup_deleteBtn__\\+PFBA svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.TableViewPopup_deleteBtn__\\+PFBA:hover,
.TableViewPopup_deleteBtn__\\+PFBA:active,
.TableViewPopup_deleteBtn__\\+PFBA:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.TableViewPopup_confirmBtn__TeC2Y {
  background-color: #131F43 !important;
  min-width: 130px !important;
  height: 50px !important;
  color: #fff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border: none !important;
}

.TableViewPopup_confirmBtn__TeC2Y:hover,
.TableViewPopup_confirmBtn__TeC2Y:active,
.TableViewPopup_confirmBtn__TeC2Y:focus {
  background-color: #0f1824 !important;
}

.TableViewPopup_confirmBtn__TeC2Y svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.TableViewPopup_delPopContainer__JGVWI .TableViewPopup_modal-body__cHyaE {
  padding: 35px;
  text-align: center;
}

.TableViewPopup_delPopContainer__JGVWI .TableViewPopup_delet_icon__922fy {
  margin-bottom: 11px;
}

.TableViewPopup_delPopContainer__JGVWI p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
  padding: 0 20px;
}

.TableViewPopup_arrowback__zhNwv svg {
  fill: #000;
}

.TableViewPopup_bodythemedark__eT38U .TableViewPopup_arrowback__zhNwv {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.TableViewPopup_bodythemedark__eT38U .TableViewPopup_arrowback__zhNwv svg {
  fill: #3b82f6;
}

.TableViewPopup_bodythemedark__eT38U .TableViewPopup_drpdwn_btn__tA3kq {
  background-color: #132337;
}

.TableViewPopup_bodythemedark__eT38U .TableViewPopup_empname__cUDDH {
  color: #92afd3 !important;
}

.TableViewPopup_bodythemedark__eT38U .TableViewPopup_navitemli__GyHqs a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.TableViewPopup_bodythemedark__eT38U .TableViewPopup_tabnavli__-xb-e a.TableViewPopup_settingsgeneral__hwXei,
.TableViewPopup_bodythemedark__eT38U .TableViewPopup_tabnavli__-xb-e a.TableViewPopup_settingslinks__TqsRQ:hover {
  background-color: #3b82f6;
  color: #fff;
}

.TableViewPopup_bodythemedark__eT38U .TableViewPopup_tabnavli__-xb-e a.TableViewPopup_settingslinks__TqsRQ {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.TableViewPopup_headerthemedark__LXffa .TableViewPopup_dropdown_menu_contain__8qV5U {
  background-color: #1c2e45;
  color: #fff;
}

.TableViewPopup_headerthemedark__LXffa .TableViewPopup_dropdown_menu_contain__8qV5U ul li a,
.TableViewPopup_headerthemedark__LXffa .TableViewPopup_dropdown_menu_contain__8qV5U .TableViewPopup_dropdown_item__q7Q3L,
.TableViewPopup_headerthemedark__LXffa .TableViewPopup_dropdown_menu_contain__8qV5U .TableViewPopup_dropdown_item__q7Q3L h5 {
  color: #fff;
}

.TableViewPopup_headerthemedark__LXffa .TableViewPopup_dropdown_menu_contain__8qV5U ul li a:hover,
.TableViewPopup_headerthemedark__LXffa .TableViewPopup_dropdown_menu_contain__8qV5U .TableViewPopup_dropdown_item__q7Q3L:hover {
  background-color: #132337;
  color: #fff;
}

.TableViewPopup_dropdown_item__q7Q3L:active {
  background-color: #F5F6FA;
}

.TableViewPopup_profile_arrrow_dwn__toBPJ {
  stroke: #132337;
}

.TableViewPopup_headerthemedark__LXffa .TableViewPopup_profile_arrrow_dwn__toBPJ {
  stroke: #fff;
}

.TableViewPopup_dateinputbox1__1Ep5a input,
.TableViewPopup_dateinputbox1__1Ep5a span {
  color: #fff !important;
}

/* LOGOUT MODAL */
.TableViewPopup_delPopContainer__JGVWI .TableViewPopup_modal-content__35zSX {
  border-radius: 10px;
  min-width: 399px;
}

.TableViewPopup_larg_model__WoqFK .TableViewPopup_modal-dialog__Lc0ex {
  max-width: 100% !important;
}

.TableViewPopup_larg_model__WoqFK .TableViewPopup_modal-content__35zSX {
  /* display: inline-block; */
  height: 100%;
  max-width: 900px;
  margin: auto;
  border-radius: 54px !important;
  background: #FFF;
  padding: 53px 53px 23px;
}

.TableViewPopup_larg_model__WoqFK .TableViewPopup_modal-header__HbMS1 {
  padding: 0px 0px 23px;
  border-bottom: 1px dashed #D4D9EE;
  display: block;
}

body .TableViewPopup_btn-primary__Ledqq:hover {
  background-color: transparent;
  border-color: #131F43;
  color: #131F43;
  fill: #131F43;
  border: 1px solid;
}

.TableViewPopup_form-select__ASzaB {
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  -moz-padding-start: calc(0.75rem - 3px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

thead .TableViewPopup_CustomTable_tableheadlight__HuHZw__qLAWZ th:first-child,
thead .TableViewPopup_CustomTable_tableheaddark__nwqb4__4ikrW th:first-child {
  border-radius: 5px 0 0 0px;
  display: math;
}

th:first-child {
  border-radius: 0px;
  position: absolute;
}

@media only screen and (max-width: 1200px) {
  .TableViewPopup_tableheadlight__fLoF6 th {
    min-width: 270px;
  }
}
@media only screen and (max-width: 1024px) {
  .TableViewPopup_dashboard__Bk8Cv {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
    overflow-x: hidden !important;
  }
  .TableViewPopup_cont2__WSly8 {
    height: auto !important;
    padding-bottom: 10px !important;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
    height: auto !important;
  }*/
}
@media only screen and (max-width: 767px) {
  .TableViewPopup_sectionright__mOBUK {
    float: unset !important;
  }
  .TableViewPopup_dashboard__Bk8Cv {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .TableViewPopup_cont2__WSly8 {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px 10px 15px !important;
  }
  .TableViewPopup_bodythemelight__fp7qv,
.TableViewPopup_bodythemedark__eT38U {
    padding-top: 110px;
  }
  .TableViewPopup_delPopContainer__JGVWI .TableViewPopup_modal-content__35zSX {
    min-width: 100%;
  }
  .TableViewPopup_delPopContainer__JGVWI .TableViewPopup_modal-body__cHyaE {
    padding: 15px;
  }
  .TableViewPopup_larg_model__WoqFK .TableViewPopup_modal-content__35zSX {
    border-radius: 20px !important;
    padding: 22px;
  }
}
@media (min-width: 576px) {
  .TableViewPopup_exer_modal_contain__nwIVN .TableViewPopup_modal-dialog__Lc0ex {
    max-width: 1055px;
  }
  .TableViewPopup_delPopContainer__JGVWI .TableViewPopup_modal-dialog__Lc0ex {
    max-width: 350px;
  }
  /*.tableheadlight th {
    min-width: 120px;
  } */
}
/* vk new changes */
.TableViewPopup_active_show_outer__NcX8E h2 {
  color: var(--Font-black, #0B0D0F);
  font-family: Urbanist;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
@media screen and (max-width: 768px) {
  .TableViewPopup_active_show_outer__NcX8E h2 {
    margin-top: 15px;
  }
}
.TableViewPopup_active_show_outer__NcX8E .TableViewPopup_active_show_inner__3A37U {
  width: 100%;
  display: block;
}
.TableViewPopup_active_show_outer__NcX8E .TableViewPopup_active_show_inner__3A37U .TableViewPopup_act_box_img__gvVo8 {
  margin-bottom: 12px;
  min-height: 400px;
  object-fit: cover;
  overflow: hidden;
  height: 400px;
  max-height: 400px;
}
@media (max-width: 767px) {
  .TableViewPopup_active_show_outer__NcX8E .TableViewPopup_active_show_inner__3A37U .TableViewPopup_act_box_img__gvVo8 {
    min-height: 300px;
    height: 300px;
    max-height: 300px;
  }
}
.TableViewPopup_active_show_outer__NcX8E .TableViewPopup_active_show_inner__3A37U .TableViewPopup_act_box_img__gvVo8 img {
  max-height: 400px;
  /* align-self: stretch; */
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: cover;
}
.TableViewPopup_active_show_outer__NcX8E .TableViewPopup_active_show_inner__3A37U .TableViewPopup_act_box_cnt__zzbwA {
  width: 100%;
  display: block;
}
.TableViewPopup_active_show_outer__NcX8E .TableViewPopup_active_show_inner__3A37U .TableViewPopup_act_box_cnt__zzbwA svg {
  flex-shrink: 0;
}
.TableViewPopup_active_show_outer__NcX8E .TableViewPopup_active_show_inner__3A37U .TableViewPopup_act_box_cnt__zzbwA .TableViewPopup_act_box_bdg__JOox- {
  width: 100%;
  margin-bottom: 12px;
}
.TableViewPopup_active_show_outer__NcX8E .TableViewPopup_active_show_inner__3A37U .TableViewPopup_act_box_cnt__zzbwA .TableViewPopup_act_box_bdg__JOox- span {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right top no-repeat;
  width: 111px;
  display: block;
  height: 34px;
  color: var(--White, #FFF);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  padding: 3px 8px;
}
.TableViewPopup_active_show_outer__NcX8E .TableViewPopup_active_show_inner__3A37U .TableViewPopup_act_box_cnt__zzbwA .TableViewPopup_act_box_bdg__JOox- .TableViewPopup_sold__f4Ooc {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) right top no-repeat !important;
}
.TableViewPopup_active_show_outer__NcX8E .TableViewPopup_active_show_inner__3A37U .TableViewPopup_act_box_cnt__zzbwA h3 {
  color: var(--Secondary, #132941);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 26.304px;
  margin: 0;
}
.TableViewPopup_active_show_outer__NcX8E .TableViewPopup_active_show_inner__3A37U .TableViewPopup_act_box_cnt__zzbwA p {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
}
.TableViewPopup_active_show_outer__NcX8E .TableViewPopup_active_show_inner__3A37U .TableViewPopup_act_box_cnt__zzbwA p span {
  color: var(--Light-1, #736B66);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 26.304px;
}
.TableViewPopup_active_show_outer__NcX8E .TableViewPopup_active_show_inner__3A37U .TableViewPopup_act_box_cnt__zzbwA p .TableViewPopup_timezone_code_pill__7TmBB {
  display: inline-block;
  padding: 2px 8px;
  margin-left: 4px;
  background: #e0f2fe;
  color: #0369a1;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  border-radius: 6px;
}

/* vk new changes */
#TableViewPopup_attent_details_row1__GU9l\\+ {
  margin-bottom: 0 !important;
}

.TableViewPopup_attent_details__5UfU5 .TableViewPopup_attent_details_inner__0cPFU {
  display: flex;
  gap: 61px;
  padding: 20px;
  border-radius: 5px;
  background: #FFF;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
  align-items: center;
}
@media (max-width: 576px) {
  .TableViewPopup_attent_details__5UfU5 .TableViewPopup_attent_details_inner__0cPFU {
    display: block !important;
  }
}
@media (max-width: 992px) {
  .TableViewPopup_attent_details__5UfU5 .TableViewPopup_attent_details_inner__0cPFU {
    display: flex;
    gap: 20px;
    align-items: start;
  }
}
.TableViewPopup_attent_details__5UfU5 .TableViewPopup_attent_details_inner__0cPFU .TableViewPopup_attent_details_inner_l__g2m43 img {
  width: 187px;
  height: 207px;
  flex-shrink: 0;
  object-fit: cover;
}
.TableViewPopup_attent_details__5UfU5 .TableViewPopup_attent_details_inner__0cPFU .TableViewPopup_attent_details_inner_r__88edv {
  flex: 1 1;
}
.TableViewPopup_attent_details__5UfU5 .TableViewPopup_attent_details_inner__0cPFU .TableViewPopup_attent_details_inner_r__88edv .TableViewPopup_attent_details_row__yYBLp {
  display: flex;
  gap: 20px;
  margin-bottom: 28px;
}
@media (max-width: 992px) {
  .TableViewPopup_attent_details__5UfU5 .TableViewPopup_attent_details_inner__0cPFU .TableViewPopup_attent_details_inner_r__88edv .TableViewPopup_attent_details_row__yYBLp {
    margin-bottom: 0px;
    display: inline-block;
    width: 100%;
  }
}
.TableViewPopup_attent_details__5UfU5 .TableViewPopup_attent_details_inner__0cPFU .TableViewPopup_attent_details_inner_r__88edv .TableViewPopup_attent_details_row__yYBLp .TableViewPopup_attent_details_row_box__2783n {
  flex: 1 1;
  width: 22%;
}
@media (max-width: 576px) {
  .TableViewPopup_attent_details__5UfU5 .TableViewPopup_attent_details_inner__0cPFU .TableViewPopup_attent_details_inner_r__88edv .TableViewPopup_attent_details_row__yYBLp .TableViewPopup_attent_details_row_box__2783n {
    margin: 15px 0px 10px !important;
    width: 100% !important;
  }
}
@media (max-width: 992px) {
  .TableViewPopup_attent_details__5UfU5 .TableViewPopup_attent_details_inner__0cPFU .TableViewPopup_attent_details_inner_r__88edv .TableViewPopup_attent_details_row__yYBLp .TableViewPopup_attent_details_row_box__2783n {
    margin-bottom: 15px;
    float: left;
    margin-right: 0;
    width: 50%;
    padding-right: 10px;
  }
}
.TableViewPopup_attent_details__5UfU5 .TableViewPopup_attent_details_inner__0cPFU .TableViewPopup_attent_details_inner_r__88edv .TableViewPopup_attent_details_row__yYBLp .TableViewPopup_attent_details_row_box__2783n p {
  margin-bottom: 10px;
  color: #727272;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.TableViewPopup_attent_details__5UfU5 .TableViewPopup_attent_details_inner__0cPFU .TableViewPopup_attent_details_inner_r__88edv .TableViewPopup_attent_details_row__yYBLp .TableViewPopup_attent_details_row_box__2783n h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  word-wrap: break-word;
}
.TableViewPopup_attent_details__5UfU5 .TableViewPopup_attent_details_inner__0cPFU .TableViewPopup_attent_details_inner_r__88edv .TableViewPopup_attent_details_row_last__S\\+DNY {
  margin-bottom: 0px !important;
}
.TableViewPopup_attent_details__5UfU5 .TableViewPopup_attent_details_inner__0cPFU .TableViewPopup_attent_details_inner_r__88edv .TableViewPopup_attent_details_row_last__S\\+DNY.TableViewPopup_interesting_fact__AOO1A {
  padding-top: 30px;
}
.TableViewPopup_attent_details__5UfU5 .TableViewPopup_attent_details_inner__0cPFU .TableViewPopup_attent_details_inner_r__88edv .TableViewPopup_attent_details_row_last__S\\+DNY.TableViewPopup_interesting_fact__AOO1A .TableViewPopup_attent_details_row_box__2783n {
  width: 100%;
}
.TableViewPopup_attent_details__5UfU5 .TableViewPopup_attent_details_inner__0cPFU .TableViewPopup_attent_details_inner_r__88edv .TableViewPopup_attent_details_row_last__S\\+DNY.TableViewPopup_interesting_fact__AOO1A .TableViewPopup_attent_details_row_box__2783n h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.TableViewPopup_showbox_sec__qlOT2 {
  display: flex;
  justify-content: flex-start;
  gap: 0;
  flex-direction: row;
  flex-wrap: wrap;
}
@media screen and (max-width: 500px) {
  .TableViewPopup_showbox_sec__qlOT2 {
    justify-content: center;
  }
}

.TableViewPopup_show_box_main__46eqU {
  margin: 10px 0px;
}
.TableViewPopup_show_box_main__46eqU .TableViewPopup_show_box__h5wYJ {
  min-height: 600px;
  width: 300px;
  float: left;
  margin-right: 20px;
  margin-bottom: 20px;
  cursor: pointer;
}
@media (max-width: 1024px) {
  .TableViewPopup_show_box_main__46eqU .TableViewPopup_show_box__h5wYJ {
    margin-right: 18px;
  }
}
@media (max-width: 767px) {
  .TableViewPopup_show_box_main__46eqU .TableViewPopup_show_box__h5wYJ {
    min-height: 500px;
    width: 200px !important;
  }
}
.TableViewPopup_show_box_main__46eqU .TableViewPopup_show_box__h5wYJ img {
  max-height: 400px;
  height: 100%;
  width: 100%;
}
@media (max-width: 767px) {
  .TableViewPopup_show_box_main__46eqU .TableViewPopup_show_box__h5wYJ img {
    max-height: 300px !important;
  }
}
.TableViewPopup_show_box_main__46eqU .TableViewPopup_show_box__h5wYJ:last-child {
  margin-right: 0px !important;
}
.TableViewPopup_show_box_main__46eqU .TableViewPopup_no_show_box__Mq8IK {
  width: 350px;
  margin: 0 auto 20px;
  display: block;
}
@media (max-width: 767px) {
  .TableViewPopup_show_box_main__46eqU .TableViewPopup_no_show_box__Mq8IK {
    width: 250px !important;
  }
}
.TableViewPopup_show_box_main__46eqU .TableViewPopup_no_show_box__Mq8IK img {
  max-height: 450px;
  height: 100%;
  width: 100%;
}
@media (max-width: 767px) {
  .TableViewPopup_show_box_main__46eqU .TableViewPopup_no_show_box__Mq8IK img {
    max-height: 350px !important;
  }
}
.TableViewPopup_show_box_main__46eqU .TableViewPopup_no_show_box__Mq8IK h6 {
  color: #000;
  text-align: center;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 20px;
}
@media only screen and (max-width: 600px) {
  .TableViewPopup_show_box_main__46eqU .TableViewPopup_no_show_box__Mq8IK h6 {
    font-size: 20px;
  }
}

.TableViewPopup_attent_flex__ZeCsY {
  justify-content: space-between !important;
  gap: 30px;
  align-items: center;
}
.TableViewPopup_attent_flex__ZeCsY h5 {
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
}

/* Popup style */
.TableViewPopup_popupbox__a0ady {
  position: fixed;
  background: rgba(0, 0, 0, 0.46);
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 99;
}

#TableViewPopup_box__2aK4E {
  position: relative;
  width: 55%;
  margin: 0 auto;
  height: auto;
  max-height: 70vh;
  margin-top: calc(30vh - 20px);
  border-radius: 4px;
  padding: 20px;
  overflow: auto;
}

.TableViewPopup_closeicon__xX-PQ {
  content: "x";
  cursor: pointer;
  position: fixed;
  right: calc(22% - 18px);
  top: calc(27vh - 25px);
  background: #ededed;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  line-height: 20px;
  text-align: center;
  border: 1px solid #999;
  font-size: 20px;
}

#TableViewPopup_addheading__L0Wjm {
  font-size: 20px;
}

.TableViewPopup_nametitle__1BORB {
  font-size: 16px;
}

.TableViewPopup_name__d-fY- {
  font-size: 16px;
  color: #fff;
}

.TableViewPopup_detailsdiv__v6KtY {
  padding: 5px;
  background-color: #fff;
}

.TableViewPopup_profilepicdiv__JsY9Q {
  border-radius: 5px;
}

.TableViewPopup_profile_imgsection__Tz7nf {
  display: flex;
  justify-content: center;
  align-items: center;
}

.TableViewPopup_profilepic__igUKH {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 1px solid rgba(33, 37, 41, 0.4588235294);
  padding: 5px;
}

.TableViewPopup_namesection__jDhA7 {
  text-align: center;
}

#TableViewPopup_profilename__xS1eF {
  font-size: 14px;
  margin-top: 30px;
  text-align: center;
}

.TableViewPopup_profileemail__sIv64 {
  font-size: 12px;
}

#TableViewPopup_profiledob__CoUKF {
  font-size: 12px;
}

#TableViewPopup_empdiv__2\\+KYM {
  padding: 5px 0px 0px 15px;
  margin-bottom: 10px;
  border-radius: 5px;
}
#TableViewPopup_empdiv__2\\+KYM .TableViewPopup_title__QI5k1 {
  font-size: 13px;
}
#TableViewPopup_empdiv__2\\+KYM .TableViewPopup_empname__cUDDH {
  font-size: 14px;
  padding-bottom: 8px;
  word-break: break-word;
}

@media only screen and (max-width: 400px) {
  #TableViewPopup_box__2aK4E {
    width: 80%;
    margin: 90px 40px;
  }
  .TableViewPopup_closeicon__xX-PQ {
    right: calc(32% - 64px);
    top: calc(23vh - 25px);
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/components/TableViewPopup/TableViewPopup.module.scss"],"names":[],"mappings":"AAAA;;EAAA;AAkDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA1FO;EA2FP,gBAAA;EACA,kBAAA;ACvEF;;AD0EA;EACE,yBAAA;EACA,yBAjGO;EAkGP,kBAAA;ACvEF;;AD0EA;;;EAGE,yBApEoB;ACHtB;;AD0EA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACvEF;;AD0EA;;CAAA;AAIA;EACE,wBA1CU;EA2CV,UA1CS;EA2CT,kBAAA;EACA,aAlDiB;EAmDjB,kBAAA;EACA,mBA3HO;EA4HP,+BAAA;EACA,YAAA;EACA,2BAAA;EACA;;;GAAA;ACrEF;;AD2EA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACxEF;;AD6EA;EACE,2BAAA;AC1EF;;AD6EA;EACE,yBAAA;EACA,YAAA;AC1EF;;AD8EA;EACE,YAAA;AC3EF;;AD8EA;EACE,sBA9GY;ACmCd;;AD8EA;;CAAA;AAGA;EACE,sBArHY;EAsHZ,iBAAA;AC3EF;;AD8EA;EACE,yBArIgB;EAsIhB,iBAAA;AC3EF;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;;CAAA;AAGA;EACE,sBAtIY;AC2Dd;;AD8EA;EACE,yBArJgB;AC0ElB;;AD8EA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;AC3EF;;AD8EA;;CAAA;AAGA;EACE,yBAAA;AC3EF;;AD8EA;EACE,yBA1KgB;AC+FlB;;AD8EA;;CAAA;AAGA;EACE,yBAAA;AC3EF;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;;EAEE,sBAAA;AC3EF;;AD8EA;EACE,yBA5LsB;EA6LtB,cAvMkB;AC4HpB;;AD8EA;EACE,sCAAA;EACA,sBAAA;EACA,oCAAA;AC3EF;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;EACE,sBAAA;EACA,oCAAA;AC3EF;;AD8EA;EACE,0BAAA;AC3EF;;AD8EA;EACE,uBAAA;AC3EF;;AD8EA;EACE,0BAAA;AC3EF;;AD8EA;EACE,uBAAA;AC3EF;;AD8EA;;EAEE,qBAAA;AC3EF;;AD8EA;EACE,yBArOsB;EAsOtB,WA7NY;ACkJd;;AD8EA;;CAAA;AAGA;EACE,cAjOe;ACsJjB;;AD8EA;EACE,cArOe;AC0JjB;;AD8EA;;CAAA;AAGA;EACE,sBA/OY;EAgPZ,YAAA;AC3EF;;AD8EA;EACE,yBA/PgB;EAgQhB,WArPY;EAsPZ,YAAA;AC3EF;;AD8EA;EACE,cAvPe;AC4KjB;;AD8EA;;CAAA;AAGA;EACE,yBA9Sc;EA+Sd,8BAAA;AC3EF;;AD8EA;EACE,WAtQY;AC2Ld;;AD8EA;;EAEE,0BAAA;AC3EF;;AD8EA;;EAEE,0BAAA;AC3EF;;AD8EA;EACE,kBAAA;AC3EF;;AD8EA;EACE,kBAAA;AC3EF;;AD8EA;EACE,oCAAA;EACA,gCAAA;AC3EF;;AD8EA;EACE,yBAzRkB;EA0RlB,WAlSY;ACuNd;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;EACE,iBAAA;AC3EF;;AD8EA;;EAEE,+BAAA;EACA,iBAAA;AC3EF;;AD8EA;EACE,sBApTY;ACyOd;AD6EE;EACE,sBAvTU;EAwTV,YAAA;AC3EJ;AD6EE;EACA,iBAAA;AC3EF;;ADgFA;EACE,0CAAA;EACA,cA/Te;ACkPjB;AD+EE;EACE,yCAAA;EACA,eAAA;AC7EJ;;ADiFA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC9EF;;ADiFA;EACE,yBAAA;EACA,0BAAA;AC9EF;;ADiFA;;CAAA;AAGA;EACE,sBA3VY;EA4VZ,yBAAA;EACA,qDAAA;AC9EF;;ADiFA;EACE,yBAzVkB;EA0VlB,yBAAA;EACA,eAAA;AC9EF;ADgFE;EACE,cAnWa;ACqRjB;;ADmFA;;CAAA;AAGA;EACE,yBAlXgB;ACkSlB;;ADmFA;EACE,yBAAA;EACA,yBAAA;AChFF;;ADmFA;EACE,yBAlYoB;EAmYpB,yBAAA;AChFF;;ADmFA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AChFF;;ADmFA;;CAAA;AAGA;EACE,sBAtYY;ACsTd;;ADmFA;EACE,yBAlYkB;ACkTpB;;ADoFA;;CAAA;AAGA;EACE,iGAAA;EACA,sBAnZY;ACkUd;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;EACE,gGAAA;EACA,sBA5ZY;AC2Ud;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;EACE,gGAAA;EACA,sBAraY;ACoVd;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;EACE,gGAAA;EACA,sBA9aY;AC6Vd;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;;;;;;;;EAQE,WA7bY;AC4Wd;;ADoFA;;CAAA;AAGA;EACE,qCAAA;ACjFF;;ADoFA;EACE,cArce;ACoXjB;;ADqFA;;CAAA;AAGA;EACE,sBAAA;AClFF;;ADqFA;EACE,yBAAA;AClFF;;ADqFA;EACE,yBAzekB;EA0elB,WAzdY;ACuYd;;ADqFA;EACE,yBA9ekB;EA+elB,WA9dY;AC4Yd;;ADqFA;EACE,6BAAA;AClFF;;ADqFA;EACE,2BAAA;AClFF;;ADqFA;EACE,yBA3fkB;ACyapB;;ADqFA;EACE,yBA9fwB;AC4a1B;;ADqFA;EACE,WAlfY;EAmfZ,6BAAA;EACA,yBAAA;AClFF;;ADqFA;EACE,yBAzgBkB;ACubpB;;ADsFA;EACE,yBAxgBgB;ACqblB;;ADsFA;EACE,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,wCAAA;EACA,oCAAA;EACA,yBAAA;EACA,2BAAA;ACnFF;;ADsFA;;;EAGE,oCAAA;EACA,sBAAA;ACnFF;;ADsFA;EACE,gBAAA;EACA,YAAA;EACA,WAphBY;EAqhBZ,yBAhjBY;EAijBZ,YAAA;EACA,eAAA;EACA,gBA3kBc;ACwfhB;;ADsFA;EACE,gBAAA;EACA,YAAA;EACA,WA9hBY;EA+hBZ,yBA1jBY;EA2jBZ,YAAA;EACA,eAAA;EACA,gBArlBc;ACkgBhB;;ADsFA;EACE,yBAjkBY;AC8ed;;ADsFA;EACE,yBA3jBkB;ACwepB;;ADsFA;EACE,yBA9jBwB;AC2e1B;;ADsFA;EACE,cApkBiB;ACifnB;;ADuFA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACpFF;;ADuFA;EACE,WA7jBY;EA8jBZ,yBAzlBY;EA0lBZ,YAAA;ACpFF;;ADuFA;EACE,QAAA;ACpFF;;ADuFA;EACE,gBAAA;EACA,YAAA;EACA,yBA7lBW;EA8lBX,WA1kBY;EA2kBZ,eAAA;EACA,gBA/nBc;EAgoBd,YAAA;ACpFF;;ADuFA;EACE,gBAAA;EACA,YAAA;EACA,yBAvmBW;EAwmBX,WAplBY;EAqlBZ,eAAA;EACA,gBAzoBc;EA0oBd,YAAA;ACpFF;;ADuFA;;EAEE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACpFF;;ADuFA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACpFF;;ADuFA;;;EAGE,yBA9nBW;EA+nBX,WA3mBY;EA4mBZ,YAAA;ACpFF;;ADuFA;EACE,oCAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;ACpFF;;ADuFA;;;EAGE,oCAAA;ACpFF;;ADuFA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACpFF;;ADyFA;EACE,aAAA;EACA,kBAAA;ACtFF;;ADyFA;EACE,mBAAA;ACtFF;;ADyFA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;ACtFF;;ADyFA;EACE,UAAA;ACtFF;;ADyFA;EACE,yCA3qBc;EA4qBd,cAhrBkB;AC0lBpB;;ADyFA;EACE,aAprBkB;AC8lBpB;;ADyFA;EACE,yBAhrBgB;AC0lBlB;;ADyFA;EACE,yBAAA;ACtFF;;ADyFA;EACE,6BAAA;EACA,yBAAA;EACA,WA/qBY;ACylBd;;ADyFA;;EAEE,yBArsBkB;EAssBlB,WArrBY;AC+lBd;;ADyFA;EACE,6BAAA;EACA,yBAAA;EACA,WA3rBY;ACqmBd;;ADyFA;EACE,yBAxsBsB;EAysBtB,WAhsBY;AC0mBd;;ADyFA;;;EAGE,WAtsBY;ACgnBd;;ADyFA;;EAEE,yBAttBgB;EAutBhB,WA5sBY;ACsnBd;;ADyFA;EACE,yBA9vBO;ACwqBT;;ADyFA;EACE,eA/tBgB;ACyoBlB;;ADyFA;EACE,YAxtBY;ACkoBd;;ADyFA;;EAEE,sBAAA;ACtFF;;ADyFA,iBAAA;AAKA;EACE,mBAAA;EACA,gBAAA;AC1FF;;AD6FA;EACE,0BAAA;AC1FF;;AD6FA;EACE,2BAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,uBAAA;AC1FF;;AD6FA;EACE,qBAAA;EACA,iCAAA;EACA,cAAA;AC1FF;;AD6FA;EACE,6BAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;AC1FF;;AD6FA;EACE,cAAA;EACA,WAAA;EACA,0CAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,oEAAA;AC1FF;;AD6FA;;EAEE,0BAAA;EACA,aAAA;AC1FF;;AD6FA;EACE,kBAAA;EACA,kBAAA;AC1FF;;AD6FA;EACE;IACE,gBAAA;EC1FF;AACF;AD6FA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,6BAAA;EC3FF;ED8FA;IACE,uBAAA;IACA,+BAAA;EC5FF;AACF;AD+FA;EACE;;IAAA;AC3FF;ADgGA;EACE;IACE,uBAAA;EC9FF;EDiGA;IACE,6BAAA;EC/FF;AACF;ADkGA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,kCAAA;EChGF;EDmGA;;IAEE,kBAAA;ECjGF;EDoGA;IACE,eAAA;EClGF;EDqGA;IACE,aAAA;ECnGF;EDsGA;IACE,8BAAA;IACA,aAAA;ECpGF;AACF;ADuGA;EACE;IACE,iBAAA;ECrGF;EDwGA;IACE,gBAAA;ECtGF;EDyGA;;KAAA;ACrGF;AD0GA,mBAAA;AAGE;EACE,iCAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AC1GJ;AD2GI;EAPF;IAQI,gBAAA;ECxGJ;AACF;AD2GE;EACE,WAAA;EACA,cAAA;ACzGJ;AD2GI;EACE,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;ACzGN;AD0GM;EAPF;IAQI,iBAAA;IACA,aAAA;IACA,iBAAA;ECvGN;AACF;ADwGM;EACE,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;ACtGR;AD0GI;EACE,WAAA;EACA,cAAA;ACxGN;ADyGA;EACE,cAAA;ACvGF;ADyGM;EACE,WAAA;EACA,mBAAA;ACvGR;ADyGQ;EACE,uEAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;ACvGV;AD0GQ;EACE,kFAAA;ACxGV;AD6GM;EACE,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,SAAA;AC3GR;AD8GM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AC5GR;AD8GQ;EACE,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AC5GV;AD+GQ;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;AC7GV;;ADoHA,mBAAA;AACA;EACI,2BAAA;ACjHJ;;ADoHE;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;EACA,mBAAA;ACjHJ;ADmHI;EATF;IAUI,yBAAA;EChHJ;AACF;ADkHI;EAbF;IAcI,aAAA;IACA,SAAA;IACA,kBAAA;EC/GJ;AACF;ADkHM;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;AChHR;ADoHI;EACE,SAAA;AClHN;ADoHM;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AClHR;ADoHQ;EALF;IAMI,kBAAA;IACA,qBAAA;IACA,WAAA;ECjHR;AACF;ADmHQ;EACE,SAAA;EACA,UAAA;ACjHV;ADmHU;EAJF;IAKI,gCAAA;IACA,sBAAA;EChHV;AACF;ADkHU;EATF;IAUI,mBAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,mBAAA;EC/GV;AACF;ADiHU;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AC/GZ;ADkHU;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AChHZ;ADqHM;EACE,6BAAA;ACnHR;ADoHQ;EACE,iBAAA;AClHV;ADmHU;EACE,WAAA;ACjHZ;ADkHY;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AChHd;;ADyHC;EACK,aAAA;EACF,2BAAA;EACA,MAAA;EACA,mBAAA;EACA,eAAA;ACtHJ;ADuHI;EANH;IAOK,uBAAA;ECpHJ;AACF;;ADsHA;EACE,gBAAA;ACnHF;ADqHE;EACE,iBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;ACnHJ;ADqHI;EARF;IASI,kBAAA;EClHJ;AACF;ADmHI;EAXF;IAYI,iBAAA;IACA,uBAAA;EChHJ;AACF;ADkHI;EACE,iBAAA;EACA,YAAA;EACA,WAAA;AChHN;ADkHM;EALF;IAMI,4BAAA;EC/GN;AACF;ADkHI;EACE,4BAAA;AChHN;ADoHE;EACE,YAAA;EACA,mBAAA;EACA,cAAA;AClHJ;ADoHI;EALF;IAMI,uBAAA;ECjHJ;AACF;ADmHI;EACE,iBAAA;EACA,YAAA;EACA,WAAA;ACjHN;ADmHM;EALF;IAMI,4BAAA;EChHN;AACF;ADkHI;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AChHN;ADiHM;EARF;IASI,eAAA;EC9GN;AACF;;ADqHA;EACE,yCAAA;EACA,SAAA;EACA,mBAAA;AClHF;ADoHE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;AClHJ;;AA1lCA,gBAAA;AACA;EACI,eAAA;EACA,+BAAA;EACA,WAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;AA6lCJ;;AA1lCE;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;AA6lCJ;;AA1lCE;EACE,YAAA;EACA,eAAA;EACA,eAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AA6lCJ;;AAzlCE;EACE,eAAA;AA4lCJ;;AAzlCA;EACI,eAAA;AA4lCJ;;AAzlCA;EACI,eAAA;EACA,WDIU;ACwlCd;;AAzlCA;EACI,YAAA;EACA,sBDDU;AC6lCd;;AAzlCA;EAEI,kBAAA;AA2lCJ;;AAxlCA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AA2lCJ;;AAxlCA;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gDAAA;EACA,YAAA;AA2lCJ;;AAxlCA;EACI,kBAAA;AA2lCJ;;AAxlCA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;AA2lCJ;;AAzlCA;EACI,eAAA;AA4lCJ;;AAzlCA;EACI,eAAA;AA4lCJ;;AAxlCA;EACI,yBAAA;EACA,mBAAA;EACA,kBAAA;AA2lCJ;AAzlCI;EAEI,eAAA;AA0lCR;AAvlCI;EACI,eAAA;EACA,mBAAA;EACA,sBAAA;AAylCR;;AAnlCA;EACI;IACI,UAAA;IACA,iBAAA;EAslCN;EAnlCI;IACE,uBAAA;IACA,sBAAA;EAqlCN;AACF","sourcesContent":["/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #131F43;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n$dark-active-blue : #3b82f6;\n$dark-light-blue : #92afd3;\n$addBtn-dark-blue : #3b82f6;\n$addBtn-dark-blue-hover : #2563eb;\n$backBtn-dark : #3b82f633;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131F43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  overflow-y: auto;\n  padding-right: 0px;\n}\n\n.dashboardContain {\n  width: calc(100% - 320px);\n  background-Color: $mainBg;\n  border-radius: 8px;\n}\n\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard,\n.bodythemedark .cont2 {\n  background-Color: $darkTheme_darkBlue;\n}\n\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  /*height: calc(100vh - 160px);*/\n  height: 100%;\n  min-height: auto !important;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n\n\n.cst_vendr input {\n  min-height: 35px !important;\n}\n\n.cst_vendr .form-control {\n  background-color: #f5f6fa;\n  border: none;\n}\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n.bodythemeNew {\n  background-color: #f5f6fa;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 2;\n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: #f5f6fa;\n}\n\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span,\n.menulinklight:hover a {\n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color !important;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color !important;\n}\n\n.menulinklight .sub_arrow svg path {\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path {\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinklight:hover svg path,\n.menulinklightSelected svg path {\n  fill: #fff !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n\n.tableheadlight th {\n  color: $white-color;\n}\n\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n}\n\nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child {\n  border-radius: 0 5px 0px 0;\n}\n\nth:first-child {\n  border-radius: 0px;\n}\n\ntd:last-child {\n  border-radius: 0px;\n}\n\ntable.table.table-borderless {\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n\n.tablebodylight td,\n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 45px;\n}\n\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: $white-color;\n    cursor: auto;\n  }\n  p{\n  line-height: 24px;\n}\n\n}\n\n.tablebodydark {\n  /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: pointer;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a,\n#card1bgdark p,\n#card2bgdark a,\n#card2bgdark p,\n#card3bgdark a,\n#card3bgdark p,\n#card4bgdark a,\n#card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important;\n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border-radius: 5px !important;\n  background-color: transparent !important;\n  border: solid 1px $primary-color !important;\n  color: $primary-color !important;\n  min-width: 113px !important;\n}\n\n.resetbtn:hover,\n.resetbtn:active,\n.resetbtn:focus {\n  background-color: $primary-color !important;\n  color: $white-color !important;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addDltBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important;\n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover,\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color !important;\n  min-width: 130px !important;\n  height: 50px !important;\n  color: $white-color !important;\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border: none !important;\n}\n\n.confirmBtn:hover,\n.confirmBtn:active,\n.confirmBtn:focus {\n  background-color: $darkTheme_darkBlue !important;\n}\n\n.confirmBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n\n\n.delPopContainer .modal-body {\n  padding: 35px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n  padding: 0 20px;\n}\n\n.arrowback svg {\n  fill: #000;\n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark;\n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral,\n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item,\n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input,\n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {}\n\n.modalStyleDark {}\n\n.delPopContainer .modal-content {\n  border-radius: 10px;\n  min-width: 399px;\n}\n\n.larg_model .modal-dialog {\n  max-width: 100% !important;\n}\n\n.larg_model .modal-content {\n  /* display: inline-block; */\n  height: 100%;\n  max-width: 900px;\n  margin: auto;\n  border-radius: 54px !important;\n  background: #FFF;\n  padding: 53px 53px 23px;\n}\n\n.larg_model .modal-header {\n  padding: 0px 0px 23px;\n  border-bottom: 1px dashed #D4D9EE;\n  display: block;\n}\n\nbody .btn-primary:hover {\n  background-color: transparent;\n  border-color: #131F43;\n  color: #131F43;\n  fill: #131F43;\n  border: 1px solid;\n}\n\n.form-select {\n  display: block;\n  width: 100%;\n  padding: .375rem 2.25rem .375rem .75rem;\n  -moz-padding-start: calc(0.75rem - 3px);\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #212529;\n  background-color: #fff;\n  background-image: url(../../assets/select_arow.svg) !important;\n}\n\nthead .CustomTable_tableheadlight__HuHZw th:first-child,\nthead .CustomTable_tableheaddark__nwqb4 th:first-child {\n  border-radius: 5px 0 0 0px;\n  display: math;\n}\n\nth:first-child {\n  border-radius: 0px;\n  position: absolute;\n}\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 270px;\n  }\n}\n\n@media only screen and (max-width: 1024px) {\n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n    overflow-x: hidden !important;\n  }\n\n  .cont2 {\n    height: auto !important;\n    padding-bottom: 10px !important;\n  }\n}\n\n@media only screen and (max-width: 998px) {\n  /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n\n@media only screen and (max-width: 767px) {\n  .sectionright {\n    float: unset !important;\n  }\n\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px 10px 15px !important;\n  }\n\n  .bodythemelight,\n  .bodythemedark {\n    padding-top: 110px;\n  }\n\n  .delPopContainer .modal-content {\n    min-width: 100%;\n  }\n\n  .delPopContainer .modal-body {\n    padding: 15px;\n  }\n\n  .larg_model .modal-content {\n    border-radius: 20px !important;\n    padding: 22px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n    max-width: 1055px;\n  }\n\n  .delPopContainer .modal-dialog {\n    max-width: 350px;\n  }\n\n  /*.tableheadlight th {\n    min-width: 120px;\n  } */\n}\n\n/* vk new changes */\n.active_show_outer {\n\n  h2 {\n    color: var(--Font-black, #0B0D0F);\n    font-family: Urbanist;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    @media screen and (max-width:768px) {\n      margin-top: 15px;\n    }\n  }\n\n  .active_show_inner {\n    width: 100%;\n    display: block;\n\n    .act_box_img {\n      margin-bottom: 12px;\n      min-height: 400px;\n      object-fit: cover;\n      overflow: hidden;\n      height: 400px;\n      max-height: 400px;\n      @media (max-width: 767px) {\n        min-height: 300px;\n        height: 300px;\n        max-height: 300px;\n      }\n      img {\n        max-height: 400px;\n        /* align-self: stretch; */\n        width: 100%;\n        height: 100%;\n        border-radius: 12px;\n        object-fit: cover;\n      }\n    }\n\n    .act_box_cnt {\n      width: 100%;\n      display: block;\nsvg{\n  flex-shrink: 0;\n}\n      .act_box_bdg {\n        width: 100%;\n        margin-bottom: 12px;\n\n        span {\n          background: url(../../assets/ongoing.png) right top no-repeat;\n          width: 111px;\n          display: block;\n          height: 34px;\n          color: var(--White, #FFF);\n          font-size: 18px;\n          font-style: normal;\n          font-weight: 500;\n          padding: 3px 8px;\n        }\n\n        .sold {\n          background: url(../../assets/sold.png) right top no-repeat !important;\n        }\n\n      }\n\n      h3 {\n        color: var(--Secondary, #132941);\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 26.304px;\n        margin: 0;\n      }\n\n      p {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        margin-bottom: 5px;\n\n        span {\n          color: var(--Light-1, #736B66);\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 500;\n          line-height: 26.304px;\n        }\n\n        .timezone_code_pill {\n          display: inline-block;\n          padding: 2px 8px;\n          margin-left: 4px;\n          background: #e0f2fe;\n          color: #0369a1;\n          font-size: 12px;\n          font-weight: 600;\n          letter-spacing: 0.02em;\n          border-radius: 6px;\n        }\n      }\n    }\n  }\n}\n\n/* vk new changes */\n#attent_details_row1{\n    margin-bottom: 0 !important;\n}\n.attent_details {\n  .attent_details_inner {\n    display: flex;\n    gap: 61px;\n    padding: 20px;\n    border-radius: 5px;\n    background: #FFF;\n    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);\n    align-items: center;\n\n    @media (max-width: 576px) {\n      display: block !important;\n    }\n\n    @media (max-width: 992px) {\n      display: flex;\n      gap: 20px;\n      align-items: start;\n    }\n\n    .attent_details_inner_l {\n      img {\n        width: 187px;\n        height: 207px;\n        flex-shrink: 0;\n        object-fit: cover;\n      }\n    }\n\n    .attent_details_inner_r {\n      flex: 1;\n\n      .attent_details_row {\n        display: flex;\n        gap: 20px;\n        margin-bottom: 28px;\n\n        @media (max-width: 992px) {\n          margin-bottom: 0px;\n          display: inline-block;\n          width: 100%;\n        }\n\n        .attent_details_row_box {\n          flex: 1;\n          width: 22%;\n\n          @media (max-width: 576px) {\n            margin: 15px 0px 10px !important;\n            width: 100% !important;\n          }\n\n          @media (max-width: 992px) {\n            margin-bottom: 15px;\n            float: left;\n            margin-right: 0;\n            width: 50%;\n            padding-right: 10px;\n          }\n\n          p {\n            margin-bottom: 10px;\n            color: #727272;\n            font-size: 13px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n          }\n\n          h5 {\n            color: #131F43;\n            font-size: 16px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n            word-wrap: break-word;\n          }\n        }\n      }\n\n      .attent_details_row_last {\n        margin-bottom: 0px !important;\n        &.interesting_fact {\n          padding-top: 30px;\n          .attent_details_row_box {\n            width: 100%;\n            h5 {\n              color: #131F43;\n              font-size: 16px;\n              font-style: normal;\n              font-weight: 500;\n              line-height: 24px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n .showbox_sec{\n      display: flex;\n    justify-content: flex-start;\n    gap: 0;\n    flex-direction: row;\n    flex-wrap: wrap;\n    @media screen and (max-width:500px) {\n      justify-content: center;\n    }\n }\n.show_box_main {\n  margin: 10px 0px;\n\n  .show_box {\n    min-height: 600px;\n    width: 300px;\n    float: left;\n    margin-right: 20px;\n    margin-bottom: 20px;\n    cursor: pointer;\n\n    @media (max-width: 1024px) {\n      margin-right: 18px;\n    }\n    @media (max-width: 767px) {\n      min-height: 500px;\n      width: 200px !important;\n    }\n\n    img {\n      max-height: 400px;\n      height: 100%;\n      width: 100%;\n\n      @media (max-width: 767px) {\n        max-height: 300px !important;\n      }\n    }\n\n    &:last-child {\n      margin-right: 0px !important;\n    }\n  }\n\n  .no_show_box {\n    width: 350px;\n    margin: 0 auto 20px;\n    display: block;\n  \n    @media (max-width: 767px) {\n      width: 250px !important;\n    }\n  \n    img {\n      max-height: 450px;\n      height: 100%;\n      width: 100%;\n  \n      @media (max-width: 767px) {\n        max-height: 350px !important;\n      }\n    }\n    h6 {\n      color: #000;\n      text-align: center;\n      font-size: 26px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n      margin-top: 20px;\n      @media only screen and (max-width: 600px) {\n        font-size: 20px;\n      }\n    }\n  }\n  \n\n}\n\n.attent_flex {\n  justify-content: space-between !important;\n  gap: 30px;\n  align-items: center;\n\n  h5 {\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 700;\n  }\n}","@import \"../../styles/Variables/Variables.scss\";\n\n/* Popup style */\n.popupbox {\n    position: fixed;\n    background: rgb(0 0 0 / 46%);\n    width: 100%;\n    height: 100vh;\n    top: 0;\n    left: 0;\n    z-index: 99 ;\n  }\n   \n  #box {\n    position: relative;\n    width: 55%;\n    margin: 0 auto;\n    height: auto;\n    max-height: 70vh;\n    margin-top: calc(100vh - 70vh - 20px);\n    border-radius: 4px;\n    padding: 20px;\n    overflow: auto;\n  }\n   \n  .closeicon {\n    content: 'x';\n    cursor: pointer;\n    position: fixed;\n    right: calc(22% - 18px);\n    top: calc(100vh - 73vh - 25px);\n    background: #ededed;\n    width: 25px;\n    height: 25px;\n    border-radius: 50%;\n    line-height: 20px;\n    text-align: center;\n    border: 1px solid #999;\n    font-size: 20px;\n  }\n  \n\n  #addheading{\n    font-size: 20px;\n}\n\n.nametitle{\n    font-size: 16px;\n     \n}\n.name{\n    font-size: 16px;\n    color: $white-color;\n     \n}\n.detailsdiv{\n    padding: 5px;\n    background-color: $white-color;\n}\n\n.profilepicdiv{\n    // padding: 10px;\n    border-radius: 5px;\n}\n\n.profile_imgsection{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.profilepic{\n    width: 100px;\n    height: 100px;\n    border-radius: 50%;\n    border: 1px solid #21252975;\n    padding: 5px;\n}\n\n.namesection{\n    text-align: center;\n}\n\n#profilename{\n    font-size: 14px;\n    margin-top: 30px;\n    text-align: center;\n}\n.profileemail{\n    font-size: 12px;\n     \n}\n#profiledob{\n    font-size: 12px;\n     \n}\n\n#empdiv{\n    padding:5px 0px 0px 15px;\n    margin-bottom: 10px;\n    border-radius: 5px;\n\n    .title{\n         \n        font-size: 13px;\n    }\n\n    .empname{\n        font-size: 14px;\n        padding-bottom:8px;\n        word-break: break-word;\n    }\n}\n\n\n\n@media only screen and (max-width: 400px) {\n    #box {\n        width: 80%;\n        margin: 90px 40px;\n      }\n\n      .closeicon {\n        right: calc(32% - 64px);\n        top: calc(23vh - 25px);\n      }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `TableViewPopup_dashboard__Bk8Cv`,
	"dashboardContain": `TableViewPopup_dashboardContain__tpS2Y`,
	"bodythemedark": `TableViewPopup_bodythemedark__eT38U`,
	"cont2": `TableViewPopup_cont2__WSly8`,
	"top_header": `TableViewPopup_top_header__PG0wA`,
	"top_header_inner": `TableViewPopup_top_header_inner__z02ox`,
	"subLink": `TableViewPopup_subLink__pQ1zR`,
	"cst_vendr": `TableViewPopup_cst_vendr__WSWVq`,
	"form-control": `TableViewPopup_form-control__H1J3C`,
	"footer": `TableViewPopup_footer__6yLKS`,
	"bodythemelight": `TableViewPopup_bodythemelight__fp7qv`,
	"bodythemeNew": `TableViewPopup_bodythemeNew__Emjeb`,
	"headerthemelight": `TableViewPopup_headerthemelight__Jza1g`,
	"headerthemedark": `TableViewPopup_headerthemedark__LXffa`,
	"menuthemelight": `TableViewPopup_menuthemelight__LhB3c`,
	"menuthemedark": `TableViewPopup_menuthemedark__kDS-2`,
	"menulinklight": `TableViewPopup_menulinklight__X6MCA`,
	"menulinkdarkSelected": `TableViewPopup_menulinkdarkSelected__O+6+L`,
	"menulinklightSelected": `TableViewPopup_menulinklightSelected__QmHyj`,
	"menulinkdark": `TableViewPopup_menulinkdark__0CoHZ`,
	"sub_arrow": `TableViewPopup_sub_arrow__qZFKh`,
	"headinglight": `TableViewPopup_headinglight__X-ybd`,
	"headingdark": `TableViewPopup_headingdark__K-CKc`,
	"searchboxlight": `TableViewPopup_searchboxlight__IW4y0`,
	"searchboxdark": `TableViewPopup_searchboxdark__yI0sj`,
	"tableheadlight": `TableViewPopup_tableheadlight__fLoF6`,
	"tableheaddark": `TableViewPopup_tableheaddark__ByeKf`,
	"table": `TableViewPopup_table__p20dt`,
	"table-borderless": `TableViewPopup_table-borderless__6wz24`,
	"left-section": `TableViewPopup_left-section__YKZOb`,
	"tablebodylight": `TableViewPopup_tablebodylight__eYYYF`,
	"tablebodydark": `TableViewPopup_tablebodydark__jZy-n`,
	"paginationlight": `TableViewPopup_paginationlight__x+QwH`,
	"paginationdark": `TableViewPopup_paginationdark__jrN5e`,
	"formthemelight": `TableViewPopup_formthemelight__9E6G5`,
	"formthemedark": `TableViewPopup_formthemedark__SEbrt`,
	"viewformlight": `TableViewPopup_viewformlight__pK93I`,
	"permissionboxlight": `TableViewPopup_permissionboxlight__omoDD`,
	"permissionboxdark": `TableViewPopup_permissionboxdark__dI-1S`,
	"errormsgclr": `TableViewPopup_errormsgclr__40cyw`,
	"graphclrlight": `TableViewPopup_graphclrlight__SG+F5`,
	"graphclrdark": `TableViewPopup_graphclrdark__TCTv8`,
	"card1bglight": `TableViewPopup_card1bglight__xbpCL`,
	"card1bgdark": `TableViewPopup_card1bgdark__Q9o0M`,
	"card2bglight": `TableViewPopup_card2bglight__qvHLE`,
	"card2bgdark": `TableViewPopup_card2bgdark__fuIJ1`,
	"card3bglight": `TableViewPopup_card3bglight__ybE2T`,
	"card3bgdark": `TableViewPopup_card3bgdark__UNBgK`,
	"card4bglight": `TableViewPopup_card4bglight__TKUGy`,
	"card4bgdark": `TableViewPopup_card4bgdark__1QTv4`,
	"actionbtnlight": `TableViewPopup_actionbtnlight__gwhXA`,
	"actionbtndark": `TableViewPopup_actionbtndark__a9GeW`,
	"profiledropdownlight": `TableViewPopup_profiledropdownlight__Ky5fH`,
	"profiledropdowndark": `TableViewPopup_profiledropdowndark__0TwsG`,
	"settingsection": `TableViewPopup_settingsection__1qZmP`,
	"addform": `TableViewPopup_addform__-eoSQ`,
	"savebtn": `TableViewPopup_savebtn__V2WZc`,
	"profile_conatiner": `TableViewPopup_profile_conatiner__0Hgao`,
	"ag-theme-alpine": `TableViewPopup_ag-theme-alpine__pH-D3`,
	"ag-row": `TableViewPopup_ag-row__2cNcJ`,
	"formbtn": `TableViewPopup_formbtn__CH0BD`,
	"resetbtn": `TableViewPopup_resetbtn__N+kZd`,
	"addBtn": `TableViewPopup_addBtn__IqAbp`,
	"addDltBtn": `TableViewPopup_addDltBtn__rspPp`,
	"addbtnlight": `TableViewPopup_addbtnlight__G65nX`,
	"addbtndark": `TableViewPopup_addbtndark__+1j0r`,
	"cust_addBtn": `TableViewPopup_cust_addBtn__sKmpU`,
	"deleteBtn": `TableViewPopup_deleteBtn__+PFBA`,
	"confirmBtn": `TableViewPopup_confirmBtn__TeC2Y`,
	"delPopContainer": `TableViewPopup_delPopContainer__JGVWI`,
	"modal-body": `TableViewPopup_modal-body__cHyaE`,
	"delet_icon": `TableViewPopup_delet_icon__922fy`,
	"arrowback": `TableViewPopup_arrowback__zhNwv`,
	"drpdwn_btn": `TableViewPopup_drpdwn_btn__tA3kq`,
	"empname": `TableViewPopup_empname__cUDDH`,
	"navitemli": `TableViewPopup_navitemli__GyHqs`,
	"tabnavli": `TableViewPopup_tabnavli__-xb-e`,
	"settingsgeneral": `TableViewPopup_settingsgeneral__hwXei`,
	"settingslinks": `TableViewPopup_settingslinks__TqsRQ`,
	"dropdown_menu_contain": `TableViewPopup_dropdown_menu_contain__8qV5U`,
	"dropdown_item": `TableViewPopup_dropdown_item__q7Q3L`,
	"profile_arrrow_dwn": `TableViewPopup_profile_arrrow_dwn__toBPJ`,
	"dateinputbox1": `TableViewPopup_dateinputbox1__1Ep5a`,
	"modal-content": `TableViewPopup_modal-content__35zSX`,
	"larg_model": `TableViewPopup_larg_model__WoqFK`,
	"modal-dialog": `TableViewPopup_modal-dialog__Lc0ex`,
	"modal-header": `TableViewPopup_modal-header__HbMS1`,
	"btn-primary": `TableViewPopup_btn-primary__Ledqq`,
	"form-select": `TableViewPopup_form-select__ASzaB`,
	"CustomTable_tableheadlight__HuHZw": `TableViewPopup_CustomTable_tableheadlight__HuHZw__qLAWZ`,
	"CustomTable_tableheaddark__nwqb4": `TableViewPopup_CustomTable_tableheaddark__nwqb4__4ikrW`,
	"sectionright": `TableViewPopup_sectionright__mOBUK`,
	"exer_modal_contain": `TableViewPopup_exer_modal_contain__nwIVN`,
	"active_show_outer": `TableViewPopup_active_show_outer__NcX8E`,
	"active_show_inner": `TableViewPopup_active_show_inner__3A37U`,
	"act_box_img": `TableViewPopup_act_box_img__gvVo8`,
	"act_box_cnt": `TableViewPopup_act_box_cnt__zzbwA`,
	"act_box_bdg": `TableViewPopup_act_box_bdg__JOox-`,
	"sold": `TableViewPopup_sold__f4Ooc`,
	"timezone_code_pill": `TableViewPopup_timezone_code_pill__7TmBB`,
	"attent_details_row1": `TableViewPopup_attent_details_row1__GU9l+`,
	"attent_details": `TableViewPopup_attent_details__5UfU5`,
	"attent_details_inner": `TableViewPopup_attent_details_inner__0cPFU`,
	"attent_details_inner_l": `TableViewPopup_attent_details_inner_l__g2m43`,
	"attent_details_inner_r": `TableViewPopup_attent_details_inner_r__88edv`,
	"attent_details_row": `TableViewPopup_attent_details_row__yYBLp`,
	"attent_details_row_box": `TableViewPopup_attent_details_row_box__2783n`,
	"attent_details_row_last": `TableViewPopup_attent_details_row_last__S+DNY`,
	"interesting_fact": `TableViewPopup_interesting_fact__AOO1A`,
	"showbox_sec": `TableViewPopup_showbox_sec__qlOT2`,
	"show_box_main": `TableViewPopup_show_box_main__46eqU`,
	"show_box": `TableViewPopup_show_box__h5wYJ`,
	"no_show_box": `TableViewPopup_no_show_box__Mq8IK`,
	"attent_flex": `TableViewPopup_attent_flex__ZeCsY`,
	"popupbox": `TableViewPopup_popupbox__a0ady`,
	"box": `TableViewPopup_box__2aK4E`,
	"closeicon": `TableViewPopup_closeicon__xX-PQ`,
	"addheading": `TableViewPopup_addheading__L0Wjm`,
	"nametitle": `TableViewPopup_nametitle__1BORB`,
	"name": `TableViewPopup_name__d-fY-`,
	"detailsdiv": `TableViewPopup_detailsdiv__v6KtY`,
	"profilepicdiv": `TableViewPopup_profilepicdiv__JsY9Q`,
	"profile_imgsection": `TableViewPopup_profile_imgsection__Tz7nf`,
	"profilepic": `TableViewPopup_profilepic__igUKH`,
	"namesection": `TableViewPopup_namesection__jDhA7`,
	"profilename": `TableViewPopup_profilename__xS1eF`,
	"profileemail": `TableViewPopup_profileemail__sIv64`,
	"profiledob": `TableViewPopup_profiledob__CoUKF`,
	"empdiv": `TableViewPopup_empdiv__2+KYM`,
	"title": `TableViewPopup_title__QI5k1`
};
export default ___CSS_LOADER_EXPORT___;
